import React, { createContext, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { Button, Modal, Spinner } from "react-bootstrap";
import axios from "axios";
import ModalPayment from "./components/modalPayment";
import AlertComponent from "../components/AlertComponent";
import ModalListenAudio from "./components/modalListenAudio";
import { initialState } from "../components/enum";
import { languagePayment } from "./components/json";
import TabCode from "./components/TabCode";
import { goPage } from "../components/functions";
export const UserContext = createContext();

function Page_listen() {
  const [data, setData] = useState([]);
  const [isShowModal, setIsShowModal] = useState({
    modalPayment: false,
    modalListenAudio: false,
  });
  const [error, setError] = useState(initialState);
  const [idLanguage, setIdLanguage] = useState(0);
  const [idAudio, setIdAudio] = useState(0);
  const [flagImg, setFlagImg] = useState("/static/base_images/logo.png");
  const [showModalCode, setShowModalCode] = useState(false);
  const [disabledButtons, isDisabledButtons] = useState(true);
  const [codePayment, setCodePayment] = useState("");
  const [textLang, setTextLang] = useState([]);

  useEffect(() => {
    showLoader();
    const id = new URL(window.location.href).searchParams.get("id");
    let code_payment = new URL(window.location.href).searchParams.get("code");
    setCodePayment(code_payment);
    const lang = languagePayment.filter((el) => el.id === parseInt(id));
    setTextLang(lang);
    code_payment =
      code_payment == null || code_payment === "" ? "" : code_payment;
    axios
      .get("getaudios?id=" + id + "&code_payment=" + code_payment)
      .then((res) => {
        hideLoader();
        setData(res.data);
      })
      .catch(function (error) {
        hideLoader();
        let response_error = {};
        response_error.showError = true;
        response_error.type = "danger";
        response_error.message = error.message;
        setError(response_error);
      });
    axios.get("getlanguages").then((res) => {
      let urlFlag = res.data.filter((el) => (el.Language.id == id ? el : null));
      // setFlagImg(urlFlag[0].LanguageFlag.Name);
      setIdLanguage(urlFlag[0].Language.id);
    });
  }, []);

  const handleShowModal = (id, modal) => {
    const modalsArr = ["modalPayment", "modalListenAudio"];
    setIdAudio(id);
    modalsArr.map(
      (el) =>
        el === modal &&
        setIsShowModal({ ...isShowModal, [el]: !isShowModal?.[el] })
    );
  };

  const btnShowTabCode = () => {
    setShowModalCode(!showModalCode);
  };

  const callbackButtonsDisabled = (val) => {
    isDisabledButtons(val);
  };

  const disableButtons = (purchased, freeAudio) => {
    if (purchased) {
      return false;
    } else {
      if (freeAudio === false && disabledButtons) {
        return true;
      } else {
        return false;
      }
    }
  };

  return (
    <div style={{ width: "100%", height: "100vh" }}>
      <div id="loaderSpinner">
        <Spinner animation="border" role="status" variant="light">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
      <Modal show={showModalCode}>
        <Modal.Body>
          <TabCode idLanguage={idLanguage} />
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="buttons__close"
            onClick={() => setShowModalCode(!showModalCode)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="h-100 d-flex align-content-center justify-content-center flex-column">
        <div className="d-flex w-100 justify-content-center">
          {error.showError && (
            <AlertComponent type={error.type} message={error.message} />
          )}
        </div>

        <div style={{ position: "absolute", top: "20px", right: "20px" }}>
          <img
            height={60}
            src={flagImg}
            onClick={() => goPage(window.location.origin)}
            style={{ cursor: "pointer" }}
          />
        </div>

        <div
          className="w-25 row py-4 justify-content-center flex-column container__buttons"
          style={{ gap: "20px", margin: "0 auto", minWidth: "350px" }}
        >
          {data.map((el, index) => (
            <div
              key={el.Id}
              className="mappingBtn"
              style={
                disableButtons(el.AudioPurchased, el.FreeAudio)
                  ? { opacity: ".5", pointerEvents: "none" }
                  : { opacity: "1", pointerEvents: "auto" }
              }
            >
              {el.AudioCover !== null ? (
                <div>
                  <div className={index === 0 ? "d-flex mb-4 introBtn" : ""}>
                    <img
                      onClick={
                        el.FreeAudio || el.AudioPurchased
                          ? () => handleShowModal(el.Id, "modalListenAudio")
                          : () => handleShowModal(0, "modalPayment")
                      }
                      src={el.AudioCover}
                      className={index === 0 ? "m-auto cursor" : "cursor"}
                    />
                  </div>
                  {index === 0 ? (
                    <div
                      style={{
                        display: "flex",
                        whiteSpace: "nowrap",
                        justifyContent:
                          disabledButtons && el.AudioPurchased === false
                            ? "start"
                            : "center",
                        alignItems: "center",
                        gap: "40px",
                      }}
                    >
                      <span className="h1 mb-0">
                        {languagePayment.map((el) =>
                          el.id === idLanguage ? el.index : ""
                        )}
                      </span>
                      <div
                        style={
                          (disabledButtons && el.AudioPurchased === false) ||
                          codePayment !== null
                            ? { display: "none" }
                            : { display: "block" }
                        }
                      >
                        <Button
                          variant="warning"
                          onClick={() => btnShowTabCode()}
                          className="f-size22"
                        >
                          {textLang[0]?.password}
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              ) : (
                <Button
                  className="buttonStyle"
                  onClick={
                    el.FreeAudio || el.AudioPurchased
                      ? () => handleShowModal(el.Id, "modalListenAudio")
                      : () => handleShowModal(0, "modalPayment")
                  }
                >
                  {el.Name || "Request audio"}
                </Button>
              )}
            </div>
          ))}{" "}
        </div>
      </div>

      <UserContext.Provider value={idLanguage}>
        <ModalPayment
          handleShowModal={handleShowModal}
          isShowModal={isShowModal.modalPayment}
        />
      </UserContext.Provider>

      <ModalListenAudio
        data={data}
        handleShowModal={handleShowModal}
        isShowModal={isShowModal.modalListenAudio}
        id={idAudio}
        idLanguage={idLanguage}
        callbackButtonsDisabled={callbackButtonsDisabled}
        codePayment={codePayment}
      />
      <Button
        onClick={() =>
          goPage(
            `/credits?id=${idLanguage}` +
              (codePayment ? `&code=${codePayment}` : "")
          )
        }
        className="button__credits"
        variant="warning"
      >
        Credits
      </Button>
    </div>
  );
}

ReactDOM.render(<Page_listen />, document.getElementById("pagelisten"));
